import { render, staticRenderFns } from "./giftdatacreation.vue?vue&type=template&id=58e7f835&scoped=true&"
import script from "./giftdatacreation.vue?vue&type=script&lang=js&"
export * from "./giftdatacreation.vue?vue&type=script&lang=js&"
import style0 from "./giftdatacreation.vue?vue&type=style&index=0&id=58e7f835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7f835",
  null
  
)

export default component.exports